import Uploads from "@/widgets/upload.js";

export default function (element, data) {
    let elements = element.querySelectorAll('.js-open-popup');

    let popupContainer = document.querySelector('.js-vacancy-popup');
    let popupBlock = popupContainer.querySelector('.popup-form');
    let closeBtn = popupContainer.querySelector('.close-btn');
    let input_name = popupBlock.querySelector('input[name="vacancy_name"]');
    let input_city = popupBlock.querySelector('input[name="vacancy_city"]');
    let input_link = popupBlock.querySelector('input[name="vacancy_link"]');

    elements.forEach(element => {
        let item_name = element.getAttribute('data-item_name');
        let item_city = element.getAttribute('data-item_city');
        let item_link = element.getAttribute('data-item_link') || '';

        element.addEventListener("click", function() {
            openPopup(item_name, item_city, item_link);
        });
    });

    // Обработчик открытия popup
    function openPopup(item_name, item_city, item_link) {
        input_name.value = item_name;
        input_city.value = item_city;
        input_link.value = item_link;

        document.querySelector('#js-vacancy_name').textContent = item_name;

        popupContainer.classList.add("open");
        document.body.classList.add("no-scroll");
    }

    closeBtn.addEventListener("click", function() {
        window.dispatchEvent(new CustomEvent('closeformpopup-vacancy'));
    });
    
    // Закрытие popup при клике на контейнер (вне формы)
    popupContainer.addEventListener("click", function() {
        window.dispatchEvent(new CustomEvent('closeformpopup-vacancy'));
    });

    // Предотвращение закрытия при клике на сам popupBlock
    popupBlock.addEventListener("click", function(event) {
        event.stopPropagation();
    });

    window.addEventListener("closeformpopup-vacancy", function(event) {
        // Uploads.updateFileList();

        closePopup();
    });

    // Функция закрытия popup
    function closePopup() {
        popupContainer.classList.remove("open");
        document.body.classList.remove("no-scroll");
    }
};